import React, { Fragment } from "react";
import { brandIcon } from '../../utils/icons';

const SideBar = ({ items, setActiveItem, activeItem }) => {

  return (
    <aside className="wp-sidebar-main">
      <div className="wp-sidebar-wrapper">
        <div className="wp-sidebar-logo-container">
          <div className="wp-sidebar-logo">
            {brandIcon}
          </div>
        </div>

        <div className="wp-sidebar-items-wrapper">
          <div className="wp-sidebar-items">
            {items.map((item, index) => (
              <Fragment key={index}>
                <div
                  onClick={() => setActiveItem(item.name)}
                  className={`wp-sidebar-item-wrapper ${activeItem === item.name ? "active" : ""
                    }`}
                >
                  <div className="wp-sidebar-item">
                    <p className="wp-sidebar-item-title">{item.title}</p>
                    <span className="wp-sidebar-description">{item.description}</span>
                  </div>
                  <div className="wp-sidebar-item-logo">{item.logo}</div>
                </div>
                {item.children &&
                  item.children.map((child, i) => (
                    <div
                      onClick={() => setActiveItem(child.name)}
                      key={i}
                      className={`wp-sidebar-children-wrapper ${activeItem === child.name ? "active" : ""
                        }`}
                    >
                      <div className="wp-sidebar-children-logo">
                        {child.logo}
                      </div>
                      <div className="wp-sidebar-children-content">
                        <p className="wp-sidebar-children-title">
                          {child.title}
                        </p>
                        {child.description && (
                          <span className="wp-sidebar-description">
                            {child.description}
                          </span>
                        )}
                      </div>
                    </div>
                  ))}
              </Fragment>
            ))}
          </div>
        </div>
      </div>
    </aside>
  );
};

export default SideBar;